// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__OXkIX","alignCenter":"Navbar_alignCenter__v1Qc8"};